import React, { useEffect, useState } from 'react';
import masterService from '../../services/masterService';
import { estimateTotal, formatMoney, testFromCatalogItem } from '../../utils/appointmentExtras';

/**
 * Optional: choose the tests the patient is coming for. They are only stored on the appointment and pre-fill the registration
 * screen, which prices and bills them itself, so the amount shown here is an estimate. Search is the same Investigation
 * catalogue the registration screen uses.
 */
export const TestPicker = ({ tests, onChange }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (query.trim().length < 2) {
      setResults([]);
      return undefined;
    }
    const timer = setTimeout(async () => {
      setSearching(true);
      setError('');
      try {
        const res = await masterService.getInvestigations({ search: query.trim(), isActive: true, pageSize: 10 });
        setResults(res.success && res.data?.items ? res.data.items : []);
      } catch (err) {
        setResults([]);
        setError(err.response?.data?.message || 'The test list could not be loaded.');
      } finally {
        setSearching(false);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [query]);

  const add = (inv) => {
    const item = testFromCatalogItem({ ...inv, itemType: 'TEST', code: inv.testCode, category: inv.departmentName, sample: inv.primarySampleName });
    if (!item.itemId || tests.some((t) => t.itemId === item.itemId)) return;
    onChange([...tests, item]);
    setQuery('');
    setResults([]);
  };

  return (
    <div className="apt-tests">
      <label className="apt-label" htmlFor="apt-test-search">Tests (optional)</label>
      <input id="apt-test-search" className="apt-input" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search a test by name or code" autoComplete="off" />
      {searching && <p className="apt-hint">Searching…</p>}
      {error && <p className="apt-error-text">{error}</p>}
      {results.length > 0 && (
        <ul className="apt-results">
          {results.map((inv) => (
            <li key={inv.investigationId}>
              <button type="button" onClick={() => add(inv)} disabled={tests.some((t) => t.itemId === inv.itemId)}>
                <strong>{inv.name}</strong>
                <span>{[inv.testCode, inv.departmentName, inv.baseRate ? formatMoney(inv.baseRate) : null].filter(Boolean).join(' · ')}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
      {tests.length > 0 && (
        <div className="apt-test-list">
          {tests.map((t) => (
            <span key={t.itemId} className="apt-test-chip">
              {t.name}
              <button type="button" aria-label={`Remove ${t.name}`} onClick={() => onChange(tests.filter((x) => x.itemId !== t.itemId))}>×</button>
            </span>
          ))}
          <p className="apt-hint">Estimated amount {formatMoney(estimateTotal(tests))}. The final bill is made at registration.</p>
        </div>
      )}
    </div>
  );
};

export default TestPicker;
